"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var isProductionUrl = function (url) {
    var parsedUrl = new URL(url);
    return (!parsedUrl.hostname.endsWith('.staging.feather-insurance.com') &&
        !parsedUrl.hostname.endsWith('localhost'));
};
exports.default = isProductionUrl;
